<div class="content">
  <div class="header-container">
    <div class="items">
      @for (i of items; track i; let idx = $index) {
        <h6
          class="hover-pointer"
          [class.blue]="idx === selectedIndex"
          [class.gray]="idx !== selectedIndex"
          (click)="onItemClick(idx, i.href)"
        >
          {{ i.display }}
        </h6>
      }
    </div>
    <div class="border"></div>
  </div>
  <router-outlet></router-outlet>
</div>
